/** Non-prescription, decided the way keyon decides it.
 *
 *  keyon's IsNonPrescriptionMedication is true when the row's order_number is empty, and that picks the branch
 *  HoldMedication, ClearCurrentMedicationHold and ChangeOrderForMedLogTimes take. It does not read the
 *  `nonprescription` flag: rows that predate the flag are 0 with or without an order. Medication Administration
 *  gated on the flag and pre-pour on either, so a row with no order and the flag 0 was refused in MedAdmin
 *  ("Order Number ... does not exist") while keyon would have held it (review of #336, 2026-10-10). Both read
 *  this rule now.
 */

/** The record's order number as a string, "" when it has none. GetPatientMeds rows carry order_number;
 *  MedAdmin's medication objects carry ordernumber. */
export function orderNumberOf(record) {
  const r = record || {};
  const n = r.order_number != null && r.order_number !== '' ? r.order_number : r.ordernumber;
  return n == null ? '' : String(n);
}

export function isNonPrescription(record) {
  return orderNumberOf(record) === '';
}
